import { render, staticRenderFns } from "./ReturnPhotoGallery.vue?vue&type=template&id=8e88ab82&scoped=true&"
import script from "./ReturnPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./ReturnPhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./ReturnPhotoGallery.vue?vue&type=style&index=0&id=8e88ab82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e88ab82",
  null
  
)

export default component.exports